import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { AppDiscpatch, RootState } from './store';

export const useAppDisaptch: () => AppDiscpatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
